import React, { useState } from "react";
import axios from "axios";
import useReveal from "../hooks/useReveal";
import { toast } from "sonner";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Contact = () => {
  const [ref, visible] = useReveal();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in all the fields.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Thanks for reaching out! We\u2019ll be in touch soon.");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <section id="contact" className="bg-[#eceae5] pt-4 md:pt-6 pb-20 md:pb-28">
      <div
        ref={ref}
        className={`max-w-2xl mx-auto px-6 md:px-10 reveal ${
          visible ? "is-visible" : ""
        }`}
      >
        <div>
          <h2 className="font-display text-4xl md:text-6xl text-neutral-900 leading-tight" style={{ fontWeight: 700 }}>
            Reach out
          </h2>
          <p className="font-display italic text-neutral-600 text-lg md:text-xl mt-4">
            Have a story, a question, or an idea? We&rsquo;d love to hear from you.
          </p>

          <form onSubmit={submit} className="mt-8 flex flex-col gap-5">
            <div className="flex flex-col gap-2">
              <label className="font-sans-ui text-sm text-neutral-600">Name</label>
              <Input
                value={form.name}
                onChange={upd("name")}
                data-testid="contact-name"
                className="bg-white/70 border-neutral-300 rounded-md h-12 font-sans-ui focus-visible:ring-neutral-900"
              />
            </div>
            <div className="flex flex-col gap-2">
              <label className="font-sans-ui text-sm text-neutral-600">Email</label>
              <Input
                type="email"
                value={form.email}
                onChange={upd("email")}
                data-testid="contact-email"
                className="bg-white/70 border-neutral-300 rounded-md h-12 font-sans-ui focus-visible:ring-neutral-900"
              />
            </div>
            <div className="flex flex-col gap-2">
              <label className="font-sans-ui text-sm text-neutral-600">Message</label>
              <Textarea
                value={form.message}
                onChange={upd("message")}
                rows={5}
                data-testid="contact-message"
                className="bg-white/70 border-neutral-300 rounded-md font-display text-base resize-none focus-visible:ring-neutral-900"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="contact-send"
              className="mt-2 self-start bg-neutral-900 hover:bg-neutral-700 disabled:opacity-60 text-white font-sans-ui text-[15px] px-12 py-4 rounded-full transition-all duration-300 hover:scale-[1.03]"
            >
              {loading ? "Sending\u2026" : "Send"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
